import { hintergruende } from './hintergruende.js';

export const DEFAULT_PATTERN_COLOR = '#9C92AC';
export const DEFAULT_PATTERN_OPACITY = 0.2;

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function assertHex(color) {
  if (!HEX_RE.test(String(color))) {
    throw new Error(`Ungültige Hex-Farbe: ${color}`);
  }
  return color;
}

const slugify = (title) =>
  String(title)
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/[^a-z0-9]+/g, '');

const SVG_URL_RE = /^url\("data:image\/svg\+xml,(.+)"\)$/;
const DIM_RE = /width='(\d+)'\s+height='(\d+)'/;

const buildEntry = ({ title, backgroundImage }) => {
  const match = SVG_URL_RE.exec(backgroundImage);
  if (!match) return null;
  const rawSvg = match[1];
  const dim = DIM_RE.exec(decodeURIComponent(rawSvg));
  if (!dim) return null;
  const tokenizedSvg = rawSvg
    .replace("fill='%239C92AC'", "fill='%23{C}'")
    .replace("fill-opacity='0.2'", "fill-opacity='{O}'");
  return {
    key: slugify(title),
    label: title,
    svg: tokenizedSvg,
    w: Number(dim[1]),
    h: Number(dim[2]),
  };
};

export const HERO_PATTERNS = Object.fromEntries(
  hintergruende
    .map(buildEntry)
    .filter(Boolean)
    .map((entry) => [entry.key, entry])
);

export const PATTERN_KEYS = Object.keys(HERO_PATTERNS);

export const PATTERN_LABELS = Object.fromEntries(
  Object.values(HERO_PATTERNS).map((p) => [p.key, p.label])
);

export function resolvePatternKey(input) {
  if (!input) return null;
  if (HERO_PATTERNS[input]) return input;
  const lower = String(input).toLowerCase();
  const hit = Object.values(HERO_PATTERNS).find(
    (p) => p.label.toLowerCase() === lower
  );
  return hit?.key ?? null;
}

export function patternStyle(pattern, sizeMultiplier = 1) {
  if (!pattern) return {};
  const key = resolvePatternKey(pattern.key);
  if (!key) return {};
  const def = HERO_PATTERNS[key];

  const color = HEX_RE.test(String(pattern.color))
    ? pattern.color
    : DEFAULT_PATTERN_COLOR;
  const opacity = Number.isFinite(pattern.opacity)
    ? Math.max(0, Math.min(1, pattern.opacity))
    : DEFAULT_PATTERN_OPACITY;
  const scale = Number.isFinite(pattern.scale) ? pattern.scale : 1;

  const colorNoHash = color.slice(1);
  const svg = def.svg
    .replaceAll('{C}', colorNoHash)
    .replaceAll('{O}', String(opacity));

  return {
    backgroundImage: `url("data:image/svg+xml,${svg}")`,
    backgroundSize: `${Math.round(def.w * scale * sizeMultiplier)}px ${Math.round(def.h * scale * sizeMultiplier)}px`,
    backgroundRepeat: 'repeat',
  };
}
